import { useMemo, useState } from 'react'

import { AboutScreen, makeSelectAboutVm, platformAbout, type AboutActions, type AboutClientInfo } from '@krp/platform-ui'

import { useAppSelector } from '../../app/hooks'
import { useServerBuild } from '../../update/serverBuild'
import { BUILD_ID, isNewVersion } from '../../update/version'

/** Сборка самого клиента: коммит и время зашивает `vite build`; в dev и тестах их нет. */
const CLIENT_COMMIT: string | null = BUILD_ID ?? null
const CLIENT_BUILT_AT: string | null = import.meta.env.VITE_KRP_BUILT_AT ?? null

/**
 * Binding окна «О приложении»: версии служб через шлюз, без повтора. «Обновить» просит шлюз не ждать его кэш
 * (шлюз сам ограничивает частоту). Версия клиента сравнивается с названной сервером тем же правилом, что плашка обновления.
 */
export function AboutBinding() {
  const [fresh, setFresh] = useState(false)
  const arg = useMemo(() => ({ fresh }), [fresh])
  const subscription = platformAbout.useQuerySubscription(arg)
  const query = useAppSelector(platformAbout.select(arg))
  const selectVm = useMemo(() => makeSelectAboutVm(), [])
  const serverBuild = useServerBuild()
  const client = useMemo<AboutClientInfo>(
    () => ({
      commit: CLIENT_COMMIT,
      builtAt: CLIENT_BUILT_AT,
      serverBuild,
      serverBuildDiffers: isNewVersion(CLIENT_COMMIT ?? undefined, serverBuild),
    }),
    [serverBuild],
  )
  const vm = selectVm({ query, client })

  const refetch = subscription.refetch
  const actions = useMemo<AboutActions>(
    () => ({
      reload: () => {
        // Первое «Обновить» переключает на запрос без кэша шлюза; следующие повторяют его.
        if (!fresh) setFresh(true)
        else void refetch()
      },
    }),
    [fresh, refetch],
  )
  return <AboutScreen vm={vm} actions={actions} />
}
